import React, { useEffect, useState } from 'react';
import { Route, Routes, Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, Layout } from 'antd';

import LfContent from './LfContent';
import ByContent from './ByContent';
import DetailPage from './DetailPage';
import useIsMobile from './useIsMobile';

const { Header, Sider, Content } = Layout;

const items = [
  { key: 'lfContent', label: <Link to="/lfContent">LF内容</Link> },
  { key: 'byContent', label: <Link to="/byContent">BY内容</Link> },
];

const MainPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const [selectedKey, setSelectedKey] = useState('lfContent');

  useEffect(() => {
    const currentLocation = window.location.pathname;

    if (currentLocation === '/') {
      navigate('/lfContent');
    } else {
      // 根据路由设置选中的菜单项
      const path = currentLocation.substring(1).split('/')[0]; // 去掉开头的 /，只取第一段
      if (path === 'lfContent' || path === 'byContent') {
        setSelectedKey(path);
      }
    }
  }, [navigate, location]);

  const onClick = (e) => {
    setSelectedKey(e.key);
  };

  // 从信息流进入详情时，把列表页当作"背景路由"继续挂载在页面上：
  // 返回后列表数据、已选城市、页码、滚动位置都不会丢失
  const backgroundLocation = location.state && location.state.backgroundLocation;

  const routes = (
    <Routes location={backgroundLocation || location}>
      <Route path="/lfContent" element={<LfContent />} />
      <Route path="/byContent" element={<ByContent />} />
      <Route path="/detail/:type/:id" element={<DetailPage />} />
    </Routes>
  );

  // 详情页浮层（仅从信息流点卡片进入时出现，直接打开链接则是普通整页）
  const detailOverlay = backgroundLocation ? (
    <Routes>
      <Route path="/detail/:type/:id" element={<DetailPage overlay />} />
    </Routes>
  ) : null;

  if (isMobile) {
    return (
      <Layout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
        <Header
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '0 8px',
            height: 'auto',
            minHeight: 46,
            lineHeight: 'normal',
            background: '#fff',
            borderBottom: '1px solid #f0f0f0',
            position: 'sticky',
            top: 0,
            zIndex: 10,
          }}
        >
          <div className="demo-logo" />
          <Menu
            theme="light"
            onClick={onClick}
            style={{ flex: 1, minWidth: 0, borderBottom: 'none' }}
            selectedKeys={[selectedKey]}
            mode="horizontal"
            items={items}
          />
        </Header>

        <Content style={{ padding: 12 }}>{routes}</Content>
        {detailOverlay}
      </Layout>
    );
  }

  return (
    <Layout>
      <Header
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >   
        <div className="demo-logo" />
      </Header>
      
      <Layout>
        <Sider width={200} theme="light">
          <Menu
            theme="light"
            onClick={onClick}
            style={{ width: 200 }}
            selectedKeys={[selectedKey]} 
            mode="inline"
            items={items}
          />
        </Sider>
        
        <Layout style={{ padding: '0 24px 24px' }}>
          <div style={{ flex: 1, padding: '20px', overflowX: 'auto' }}>
            {routes}
          </div>
        </Layout>
        {detailOverlay}
      </Layout>
    </Layout>
  );
};

export default MainPage;
